export default "__VITE_ASSET__CPsvwBT___"